<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <b-breadcrumb :items="pages" style="margin: 0px; padding: 5px 14px;"></b-breadcrumb>
        <div class="col-auto">
          <b-button @click="syncADAccount()" variant="warning">Synchronize AD Account</b-button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-2">
              <div class="label mt-2">Select GRO Site:</div>
              <div class="sub-label"></div>
              <b-form-select v-model="GRO" :options="GRO_options"
                label="Select GRO Site:" @change="onChangeGRO"></b-form-select>
            </div>
            <div class="col-3">
              <div class="label mt-2">Department:</div>
              <b-form-select v-model="department" :options="department_options" label="Department:" @change="onChangeDepartment"></b-form-select>
            </div>
            <div class="col-2">
              <div class="label mt-2">Add Member:</div>
              <div class="sub-label"></div>
              <b-form-select v-model="member" :options="member_options"
                label="Add Member:" @change="onChangeMember"></b-form-select>
            </div>
            <div class="col-auto align-self-end" style="width: 11.5rem">
              <button type="button" class="btn btn-primary min-w-4"
                  @click="$emit('editMemberModal', member)">ADD</button>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-auto">
              <b-button :href="safeUrl(`${ $root.frontEndUrl }/admin-member/setting-addgro`)" variant="primary">Set GRO PM</b-button>
            </div>
            <div class="col-auto">
              <b-button :href="safeUrl(`${ $root.frontEndUrl }/admin-member/setting-addisr`)" variant="primary">Set GRO ISR</b-button>
            </div>
            <div class="col-auto">
              <b-button :href="safeUrl(`${ $root.frontEndUrl }/admin-member/nre-signflow`)" variant="primary">Set NRE Flow</b-button>
            </div>
            <div class="col-auto">
              <b-button :href="safeUrl(`${ $root.frontEndUrl }/admin-member/manager-group`)" variant="warning">Manage Role Setting</b-button>
            </div>
            <div class="col-auto">
              <b-button :href="safeUrl(`${ $root.frontEndUrl }/admin-member/setting-assignFtie`)" variant="warning">FTIE Assign Rule Setting</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="table_show==true">

      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="searchedData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 :tbody-tr-class="rowClass"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(no)="data">
            <span>
              {{data.item.no}}
            </span>
          </template>

          <template #cell(name)="data">
            <span>
              {{data.item.name}}
            </span>
          </template>

          <template #cell(email)="data">
            <span>
              {{data.item.email}}
            </span>
          </template>

          <template #cell(deptno)="data">
            <span>
              {{data.item.deptno}}
            </span>
          </template>

          <template #cell(department)="data">
            <span>
              {{data.item.department}}
            </span>
          </template>

          <template #cell(manager)="data">
            <span>
              {{data.item.manager}}
            </span>
          </template>

          <template #cell(hq_sales)="data">
            <span>
              {{data.item.hq_sales}}
            </span>
          </template>

          <template #cell(role)="data">
            <span>
              {{data.item.role}}
            </span>
          </template>

          <template #cell(func_leader)="data">
            <span>
              {{data.item.func_leader}}
            </span>
          </template>

          <template #cell(active)="data">
            <span>
              {{data.item.active}}
            </span>
          </template>

          <template #cell(create_date)="data">
            <span>
              {{data.item.create_date}}
            </span>
          </template>

          <template #cell(edit)="data">
            <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                @click="$emit('editMemberModal', data.item)"></button>
          </template>

          <template #cell(delete)="data">
            <button  type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                @click="$emit('deleteModal', 'member', data.item, department)"></button>
          </template>

        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'admin',
    props: ['searchedData', 'member_options', 'department_options',
          'table_show', ],
    watch: { 
      member_options: function(newVal, oldVal) { // watch it
        if (newVal.length) {
          this.member = newVal[0].value
        }
        else {
          this.member = ''
        }
        console.log(newVal)
      },
      department_options: function(newVal, oldVal) { // watch it
        this.department = newVal[0].value
        console.log(newVal)
      }
    },
    data() {
      return {
        // function_name: 'Admin-Member Setting',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        authUrl: '',
        frontendUrl: '',
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        GRO_options_default: '',
        GRO_options: [{ value: '', text: '---Select One---' }],
        GRO: '',
        GROText: '',
        member: '',
        department: '',

        pages: [
          { text: 'Admin-Member Setting', active: true }
        ],

        fields: [
          { key: 'no', label: '#', thClass: 'align-middle', sortable: true },
          { key: 'name', label: 'GULID', thClass: 'align-middle', sortable: true },
          { key: 'email', label: 'eMAIL', thClass: 'align-middle', sortable: false },
          { key: 'deptno', label: 'Department#', thClass: 'align-middle', sortable: true },
          { key: 'department', label: 'Dept Name', thClass: 'align-middle', sortable: true },
          { key: 'manager', label: 'Manager', thClass: 'align-middle', sortable: true },
          { key: 'hq_sales', label: 'HQ Sales', thClass: 'align-middle', sortable: true },
          { key: 'role', label: 'Role', thClass: 'align-middle', sortable: true },
          { key: 'func_leader', label: 'Func Leader', thClass: 'align-middle', sortable: true },
          { key: 'create_date', label: 'Create date', thClass: 'align-middle', sortable: true },
          { key: 'edit', label: 'Edit', thClass: 'align-middle', sortable: false },
          { key: 'delete', label: 'Delete', thClass: 'align-middle', sortable: false }
        ],
        login_user_name: '',
        searching: false,
        pageDisabled: true,
      }
    },
    created() {
      let self = this;
      // self.getPage(null);

    },
    computed: {

    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
    },
    methods: {
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location.href = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var gro_option_new = new Array();
        for (i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        gro_option_new[0].text = '---Select One---'
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;

      },
      onChangeGRO(GRO) {
        let groText = GRO;
        this.GRO = GRO
        if('' === GRO){
          groText = '---Select One---';
        }
        else {
          this.department = '';
          let request_data = {
            action: '',
            GRO: this.GRO,
            department: ''
          }; 
          this.$parent.getPage(request_data)

          request_data = {
            action: 'load_selection',
            name: '',
            GRO: this.GRO
          }
          this.$parent.load(request_data)
        }
      },
      onChangeDepartment(department) {
        let departmentText = department;
        this.department = department;
        if('' === department){
          departmentText = '---Select All---';
        }
        let request_data = {
          action: '',
          GRO: this.GRO,
          department: this.department
        }; 
        this.$parent.getPage(request_data)

      },
      onChangeMember(member) {
        let memberText = member;
        this.member = member;
        if('' === member) {
          this.member = this.member_options[0].value;
        }
        else {
          let request_data = {
            action: 'load_member',
            name: this.member,
            GRO: ''
          }
          this.$parent.load(request_data)
        }
      },
      syncADAccount() {
        if (this.GRO != '') {
          let self = this;
          console.log('####syncADAccount######');
          let request_data = {
            create_date: self.$root.getTime(),
            action: 'sync',
            GRO: self.GRO
          };
          this.$parent.getPage(request_data)
        }
      },
      setNREFlow() {
        window.open(this.$root.frontEndUrl + "/admin-member/nre-signflow", "_blank")
      },
      setGROISR() {
        window.open(this.$root.frontEndUrl + "/admin-member/setting-addisr", "_blank")
      },
      setGROPM() {
        window.open(this.$root.frontEndUrl + "/admin-member/setting-addgro", "_blank")
      },
      setRole() {
        window.open(this.$root.frontEndUrl + "/admin-member/manager-group", "_blank")
      },
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item['active_status'] === false) {
          return 'table-danger';
        }
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MemberSetting.vue